"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REQUIRED_ACTIONS = exports.CAPTURE_AFFIDAVIT = exports.CAPTURE_QUESTION = exports.CAPTURE_DATE = exports.CAPTURE_EMAIL = exports.CAPTURE_PHONE = void 0;
var CAPTURE_PHONE = 'capture_phone';
exports.CAPTURE_PHONE = CAPTURE_PHONE;
var CAPTURE_EMAIL = 'capture_email';
exports.CAPTURE_EMAIL = CAPTURE_EMAIL;
var CAPTURE_DATE = 'capture_date';
exports.CAPTURE_DATE = CAPTURE_DATE;
var CAPTURE_QUESTION = 'capture_question';
exports.CAPTURE_QUESTION = CAPTURE_QUESTION;
var CAPTURE_AFFIDAVIT = 'capture_affidavit';
exports.CAPTURE_AFFIDAVIT = CAPTURE_AFFIDAVIT;
var REQUIRED_ACTIONS = [{
  id: CAPTURE_PHONE,
  title: 'Phone number',
  description: 'Require recipients to give the sender their phone number.'
}, {
  id: CAPTURE_EMAIL,
  title: 'Email',
  description: 'Require recipients to give the sender their email address.'
}, {
  id: CAPTURE_DATE,
  title: 'Calendar invite',
  description: 'Require recipients to accept a time to talk to the sender. The meeting will be added to both the recipient and senders calendar.'
}, {
  id: CAPTURE_QUESTION,
  title: 'Questions to ask',
  description: 'Require recipients to answer the predefined questions you add below.'
}, {
  id: CAPTURE_AFFIDAVIT,
  title: 'Terms to agree to',
  description: 'Require recipients to agree the predefined terms you add below.'
}];
exports.REQUIRED_ACTIONS = REQUIRED_ACTIONS;